import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchReports } from "../../../api/endpoint";
import Loader from "../../../components/loader";
import { BsInfoCircle } from "react-icons/bs";
import Table from "../../../components/table";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Chat = () => {
  const { auth } = useSelector((state) => state.login);
  const navigate = useNavigate();

  const [tableData, setTableData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const headings = [
    { name: "S No.", fieldName: "sNo", isSortable: false, sortKey: "none" },
    { name: "Reporter", fieldName: "reporter", isSortable: false, sortKey: "none" },
    { name: "Reason", fieldName: "reason", isSortable: false, sortKey: "none" },
    { name: "Status", fieldName: "status", isSortable: false, sortKey: "none" },
    { name: "Actions", fieldName: "actions", isSortable: false, sortKey: "none" },
  ];

  useEffect(() => {
    if (auth) fetchChatReports();
  }, [auth, statusFilter]);

  const handleOpenDetails = (reportId) => {
    setTimeout(() => {
      navigate("/chat-report-details", {
        state: { reportId },
      });
    }, 0);
  };

  const fetchChatReports = async () => {
    try {
      setLoading(true);

      const params = {
        type: "CHAT",
        ...(statusFilter !== "ALL" && { status: statusFilter }),
      };

      const response = await axios.get(fetchReports, {
        headers: { Authorization: `Bearer ${auth}` },
        params,
      });

      const list = response?.data?.content || [];

      const formatted = list.map((r, i) => ({
        sNo: i + 1,
        reporter: r?.reporterName,
        reason: r?.reason,
        status: r?.status,
        actions: (
          <button
            className="btn p-0 mb-1"
            onClick={() => handleOpenDetails(r?.reportId)}
            title="View Details"
            style={{ cursor: "pointer" }}
          >
            <BsInfoCircle size={20} />
          </button>
        ),
      }));

      setTableData(formatted);

      setCurrentPage(response?.data?.currentPage);
      setPageSize(response?.data?.pageSize);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Chat Report Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Filter Dropdown */}
      <div className="d-flex gap-2 align-items-center justify-content-end">
        <label>Status:</label>
        <select
          className="form-select form-select-sm w-auto"
          onChange={(e) => setStatusFilter(e.target.value)}
          value={statusFilter}
        >
          <option value="ALL">All</option>
          <option value="REVIEWING">Reviewing</option>
          <option value="ACTION_TAKEN">Action taken</option>
          <option value="REJECTED">Rejected</option>
          <option value="CLOSED">Closed</option>
        </select>
      </div>

      {/* Table */}
      <Table
        headings={headings}
        data={tableData}
        currentPage={currentPage}
        totalPages={totalPages}
        enablePagination={tableData?.length > pageSize}
        card={true}
      />

      {loading && <Loader />}
    </div>
  );
};

export default Chat;
